import {IServiceFactoryExtended} from '../service-factory-extended.interface';

export class ApiControllerBase {
    constructor(private _services: IServiceFactoryExtended) {
    }

    protected _getRoutePrefix() {
        return '';
    }

    private _buildApiRoute(route: string) {
        let url = `${this._getRoutePrefix()}${route}`;
        if(url.startsWith('/')) {
            return url;
        }
        return '/' + url;
    }

    protected _isUSRegulation() {
        return this._services.regulation.isUSRegulation();
    }


    protected _httpPost<TResponse>(route: string, requestData?: unknown): Promise<TResponse> {
        return this._services.sdk.httpPost(this._buildApiRoute(route), requestData);
    }

    protected _httpGet<TResponse>(route: string, requestData?: unknown): Promise<TResponse> {
        return this._services.sdk.httpGet(this._buildApiRoute(route), requestData);
    }
}